export enum OpgaveBedoemmesAfEnum {
    Elever = 1,
    EksterneLaerer = 2,
    Piloter = 3
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/enums/OpgaveBedoemmesAfEnum.ts